interface Props {
    textClassName?: string;
}
const LogoLarge = ({textClassName}: Props) => {
    return (
        <div className={'flex flex-col items-center relative'}>
            <img src={`/assets/images/logo.png`}
                 width={50} height={50} alt=""/>
            <span className={`${textClassName} font-semibold font-roboto`}>DataLookup</span>
        </div>
    );
}

export default LogoLarge;
